export default [
  {
    path: '/',
    component: require('./pages/Main')
  },
  {
    path: '/products',
    component: require('./pages/Products')
  }
]



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/